import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink, profile, marquee } from '../data/content';

const { FiArrowUpRight, FiMapPin, FiBriefcase, FiMessageCircle } = FiIcons;

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-bg" />
      <div className="wrap hero-grid">
        <motion.div
          className="hero-copy"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <span className="tag"><span className="tag-dot" /> Available for new projects</span>
          <h1 className="h-display">
            Hi, I'm Syed —
            <span className="line2">Full Stack Developer.</span>
          </h1>
          <p>
            {profile.tagline} I work across the entire stack — from clean React
            interfaces to robust Node.js &amp; PHP APIs and well-tuned MySQL databases.
          </p>
          <div className="hero-actions">
            <a className="btn btn-whatsapp" href={waLink} target="_blank" rel="noreferrer">
              <SafeIcon icon={FiMessageCircle} /> Contact Us
            </a>
            <a className="btn btn-ghost" href="#work">
              View my work <SafeIcon icon={FiArrowUpRight} />
            </a>
          </div>
          <div className="hero-meta">
            <span><SafeIcon icon={FiMapPin} /> {profile.location}</span>
            <span><SafeIcon icon={FiBriefcase} /> {profile.experience}</span>
            <span><span className="live-dot" /> Online now</span>
          </div>
        </motion.div>

        <motion.div
          className="hero-card"
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          <div className="hero-card-row">
            <span className="dots"><i /><i /><i /></span>
            <span className="mono" style={{ fontSize: 11, color: 'var(--muted-2)' }}>developer.js</span>
          </div>
          <pre className="code-block">
{`const syed = {
  `}<span className="k">role</span>{`: `}<span className="s">'Full Stack Developer'</span>{`,
  `}<span className="k">stack</span>{`: {
    `}<span className="k">frontend</span>{`: [`}<span className="s">'React'</span>{`, `}<span className="s">'JS'</span>{`, `}<span className="s">'CSS'</span>{`],
    `}<span className="k">backend</span>{`:  [`}<span className="s">'Node'</span>{`, `}<span className="s">'PHP'</span>{`],
    `}<span className="k">db</span>{`:      [`}<span className="s">'MySQL'</span>{`, `}<span className="s">'MariaDB'</span>{`],
  },
  `}<span className="k">available</span>{`: `}<span className="v">true</span>{`,
};`}
          </pre>
          <div className="hero-stats">
            <div><span className="num">60+</span><span className="lbl">Projects</span></div>
            <div><span className="num">9+</span><span className="lbl">Years</span></div>
            <div><span className="num">25+</span><span className="lbl">Clients</span></div>
          </div>
        </motion.div>
      </div>

      <div className="marquee">
        <div className="marquee-track">
          {[...marquee, ...marquee].map((m, i) => (
            <span key={i}><i /> {m}</span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;
